// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PriorityIcon-base__xm0CO{color:var(--gray-12)}.PriorityIcon-urgent__ylna1{color:var(--orange-a10)}.PriorityIcon-none__Yp6n3{color:var(--gray-a8)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PriorityIcon-base__xm0CO",
	"urgent": "PriorityIcon-urgent__ylna1",
	"none": "PriorityIcon-none__Yp6n3"
};
export default ___CSS_LOADER_EXPORT___;
